/**
 * Die mandantenübergreifenden Anlagen-Stammdaten: Hersteller und ihre Modelle.
 *
 * Beide Abschnitte hängen an derselben Abfrage – die Zahl „Hinterlegte Modelle" am Hersteller
 * ist dieselbe Liste, die darunter steht. Deshalb liegt der Hook hier und nicht in den
 * Abschnitten: Ein neu angelegtes Modell muss die Zeile darüber mitzählen.
 *
 * Die Auswahl eines Herstellers ist ein Filter, kein Zustand der Daten. Sie lebt hier, weil sie
 * beide Abschnitte betrifft.
 */
import React, { useState } from "react";
import HerstellerSection from "./HerstellerSection";
import ModelleSection from "./ModelleSection";
import { useAdminAnlagentypen } from "../hooks/useAdminAnlagentypen";

const AnlagentypStammdaten: React.FC = () => {
  const {
    anlagentypen,
    hersteller,
    loading,
    error,
    create,
    update,
    remove,
    createHersteller,
    updateHersteller,
    removeHersteller,
  } = useAdminAnlagentypen();
  const [herstellerFilter, setHerstellerFilter] = useState<string | null>(null);

  return (
    <>
      <HerstellerSection
        hersteller={hersteller}
        loading={loading}
        ausgewaehlt={herstellerFilter}
        onAuswahl={setHerstellerFilter}
        onCreate={createHersteller}
        onUpdate={updateHersteller}
        onDelete={async (id) => {
          await removeHersteller(id);
          // Der Filter zeigte auf eine Zeile, die es nicht mehr gibt.
          setHerstellerFilter((bisher) => (bisher === id ? null : bisher));
        }}
      />
      <ModelleSection
        anlagentypen={anlagentypen}
        hersteller={hersteller}
        loading={loading}
        error={error}
        herstellerFilter={herstellerFilter}
        onFilterAufheben={() => setHerstellerFilter(null)}
        onCreate={create}
        onUpdate={update}
        onDelete={remove}
      />
    </>
  );
};

export default AnlagentypStammdaten;
